var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isNFTActive, metadataCallBatcher } from "@ledgerhq/coin-framework/nft/support";
import { getCryptoCurrencyById } from "@ledgerhq/coin-framework/currencies/index";
import NftApi from "./api/nft";
export const nftMetadata = ({ contract, tokenId, currencyId, metadata, }) => __awaiter(void 0, void 0, void 0, function* () {
    // This is for test/mock purposes
    if (typeof metadata !== "undefined") {
        return {
            status: 200,
            result: Object.assign({ contract,
                tokenId }, metadata),
        };
    }
    const currency = getCryptoCurrencyById(currencyId);
    if (!isNFTActive(currency)) {
        throw new Error("Ethereum Bridge NFT Resolver: Unsupported currency");
    }
    const response = yield metadataCallBatcher(currency, NftApi).loadNft({
        contract,
        tokenId,
    });
    return response;
});
export const collectionMetadata = ({ contract, currencyId, metadata, }) => __awaiter(void 0, void 0, void 0, function* () {
    // This is for test/mock purposes
    if (typeof metadata !== "undefined") {
        return {
            status: 200,
            result: Object.assign({ contract }, metadata),
        };
    }
    const currency = getCryptoCurrencyById(currencyId);
    if (!isNFTActive(currency)) {
        throw new Error("Ethereum Bridge NFT Resolver: Unsupported currency");
    }
    const response = yield metadataCallBatcher(currency, NftApi).loadCollection({
        contract,
    });
    return response;
});
export default { nftMetadata, collectionMetadata };
//# sourceMappingURL=nftResolvers.js.map